
module fdm.flightEvents {
    angular.module('fdm.flightEvents', []);
}